<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card>
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">shopping_cart</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n['orders'] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n['all_orders_details'] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0">
                        <v-row class="align-center">
                          <v-col cols="12" class="text-center py-0" FILTER  v-if="master">
                            <v-text-field
                              :label="i18n['search_by_phone_name_document_number']"
                              outlined
                              :loading="loading"
                              prepend-icon="search"
                              :class="`${arabic?'arFont':'enFont'}`"
                              hide-details
                              v-model="search"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="fromDate"
                                  :label="i18n['from_date']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  outlined
                                  hide-details
                                  dense
                                  :class="`${arabic?'arFont':'enFont'}`"

                                  @change="filterLeads()"
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="fromDate"
                                @change="filterLeads()"
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="toDate"
                                  :label="i18n['to_date']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  hide-details
                                  outlined
                                  @change="filterLeads()"
                                  dense
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="toDate"
                                @change="filterLeads()"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-autocomplete
                              :items="resource.statuses"
                              v-model="selectedStatus"
                              :label="i18n.status"
                              autocomplete="disabled"
                              outlined
                              hide-details
                              clearable
                              dense
                              :loading="loading"
                              prepend-icon="task_alt"
                              @change="filterLeads()"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{statuses_obj[item] ? statuses_obj[item][language] : ''}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{statuses_obj[item] ? statuses_obj[item][language] : item}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" v-if="hasLoadedAccounts" FILTER>
                            <AccountAutocomplete
                              :accounts="resource.accounts"
                              :selectedItem="selectedAccount"
                              @on-selected="accountChangedHandler"
                              :loading="loading"
                            />
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" FILTER>
                            <v-switch
                              hide-details inset
                              :class="`${arabic?'arFont':'enFont'} mt-0`"  @change="filterLeads()"
                              :label="i18n['no_delivery_date']"
                              v-model="noDeliveryDate">
                            </v-switch>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" FILTER>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN  v-if="master">
                            <v-btn
                              color="secondary"
                              block
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                              @click="loadResource()">
                              {{ i18n["search"] }}
                              <v-icon right size="15">search</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN v-if="master">
                            <v-btn
                              color="success"
                              block
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                              @click="exportResource()">
                              {{ i18n['export_orders'] }}
                              <v-icon right size="15">file_download</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN v-if="master">
                              <v-btn
                                color="success"
                                block
                                :loading="loading"
                                :class="`${arabic ? 'arFont' : 'enFont'}`"
                                @click="exportResource(true)">
                                {{ i18n['export_items'] }}
                                <v-icon right size="15">file_download</v-icon>
                              </v-btn>
                            </v-col>
                          <v-col cols="12" md="4" class="text-center py-0" BTN v-if="master">
                            <v-btn
                              color="error"
                              text
                              block
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                              @click="removeTests()">
                              Remove Tests
                              <v-icon right size="15">delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} text-center pa-2`">
                        <span v-if="resource.data" :class="`${arabic?'arFont':'enFont'}`"> {{ i18n['orders'] }} ({{ resource.total }})</span>
                      </v-col>
                      <v-col cols="12" md="8" class="text-center pa-2">
                        <Paging
                          :resourceSettings="resourceSettings"
                          :resource="resource"
                          @loadResource="loadResource"
                          @pageByNumber="pageByNumber"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="text-center pa-2">
                        <div
                          v-if="resource.time"
                          style="font-size:11px;direction:ltr!important;"
                          :class="`${arabic?'arFont':'enFont'}`">
                          {{(resource.time * 1000 ).toFixed(0)}}  ms
                        </div>
                        <v-progress-circular v-if="loading" color="primary" :indeterminate="true"></v-progress-circular>
                      </v-col>
                      <v-col cols="12">
                        <LeadsList :leads="resource.data" @clipboardSuccessHandler="clipboardSuccessHandler" @clipboardErrorHandler="clipboardErrorHandler" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountAutocomplete from '@/components/AccountAutocomplete';
import Paging from '@/components/Paging';
import LeadsList from '@/components/LeadsListMaster';
import json2csv from 'json2csv';

export default {
  components: { LeadsList, Paging, AccountAutocomplete },
  data() {
    return {
      loading: false,
      dialog: false,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: (value) => !!value || this.i18n.required,
        email: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n.valid_email,
      },
      resourceKeys: [

      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      newResource: {},
      editing: false,
      deleting: false,
      firstPanel: true,
      secondPanel: false,
      thirdPanel: false,
      selectedPanel: 'firstPanel',
      subitems: [
        {
          text: 'اضافة طلب جديد',
          icon: 'add_shopping_cart',
          value: 'firstPanel',
        },
        // {
        //   text:'التوصل مع الدعم',
        //   icon:'support_agent',
        //   value:'secondPanel'
        // },
      ],
      menu1: false,
      fromDate: null,
      menu2: false,
      toDate: null,
      statuses: [],
      selectedStatus: null,
      selectedAccount: null,
      noDeliveryDate: null,
    };
  },
  methods: {
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true;
      return a;
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', 'Copied', 'success');
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', 'Failed', 'error');
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${n}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('postResource', { resource: `${this.$route.path}/search?page=${n}`, value: this.search });
          
          this.$emit('snackbarNotification', `${this.i18n["number_of_orders_found"]}: ${this.resource.data.length}`, 'success')
        }
        this.loading = false;
      });
    },
    goTo(path) {
      this.$router.push(path).catch((x) => {});
    },
    buildFilter() {
      let filter = '';
      if (this.fromDate && this.toDate) {
        filter += `&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`;
      }
      if (this.selectedStatus) {
        filter += `&filter[status]=${this.selectedStatus}`;
      }
      if (this.selectedAccount) {
        filter += `&filter[account_id]=${this.selectedAccount.id}`;
      }
      if (this.noDeliveryDate) {
        filter += `&filter[no_delivery_date]=${this.noDeliveryDate}`;
      }
      return filter;
    },
    async filterLeads() {
      await this.loadResource();
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: `${this.$route.path}?${this.buildFilter()}` });
          console.log('resource', this.resource.accounts);
          // console.log(this.resource)
        } else {
          // console.log('search', this.search)
          this.resource = await this.$store.dispatch('postResource', { resource: `${this.$route.path}-search?${this.buildFilter()}`, value: { search: this.search } });
        }
        this.loading = false;
        res();
      });
    },
    async removeTests() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        const exp = await this.$store.dispatch('getResource', { resource: '/remove_tests' });
        this.loadResource();
        this.loading = false;
        res();
      });
    },
    async exportResource(item = false) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        const exp = await this.$store.dispatch('getDirectResource', { resource: '/leads-master-export' + `?${this.buildFilter()}${item?'&item=true':''}` });
        this.exportSimpleData(exp, 'leads');
        this.loading = false;
        res();
      });
    },
    exportSimpleData(data, name) {
      const a = json2csv.parse(data);
      // console.log(a)
      const csvContent = 'data:text/csv;charset=utf-8,';
      const encodedUri = csvContent + encodeURIComponent(a);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      const n = name || 'failed_export';
      link.setAttribute('download', `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    showPannel(v) {
      this[v] = true;
      const all = this.subitems.map((x) => x.value);
      all.filter((x) => x != v).forEach((x) => this[x] = false);
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')];
    },

    accountChangedHandler(accountInfo) {
      this.selectedAccount = accountInfo;
      this.filterLeads();
    },
  },
  computed: {
    master() {
      return this.user.role == 'master';
    },
    statuses_obj() {
      return this.$store.state.statuses_obj;
    },
    api() {
      return this.$store.state.settings.apiBase;
    },
    users() {
      const sa = this.$store.state.user && this.$store.state.user.role == 'superadmin';
      // console.log(sa)
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior == this.$store.state.user.level;
        } return x;
      });
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true;
    },
    routeTitle() {
      const main = this.$store.state.menu.filter((x) => x.path == this.$route.path);
      const sub = [].concat(...this.$store.state.menu.map((x) => x.subs)).filter((x) => x).filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      }
      return '';
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp);
    },
    hasLoadedAccounts() {
      return this.resource.accounts && this.resource.accounts.length;
    },
  },
  async created() {
    this.setResourceName();
    this.loadResource();
  },
};
</script>

<style>

</style>
